import { getCurrentMonthlyCycleEndDate } from 'src/components/oneCorp/features/MealCredit/utils/mealCreditDataUtils/getCurrentMonthlyCycleEndDate';
import { getFirstInstanceDateUTC } from 'src/models/LineOfCreditModelUtils';

export type MonthAvailableToParams = {
  firstInstanceEndDateUtc: string | null;
  firstInstanceUtc: string;
  durationMinutes: number;
  refreshPeriodMonthsCount: number;
};

export const calculateMonthAvailableTo = ({
  firstInstanceEndDateUtc,
  firstInstanceUtc,
  durationMinutes,
  refreshPeriodMonthsCount,
}: MonthAvailableToParams): Date => {
  if (firstInstanceEndDateUtc === null) {
    const firstInstanceStartDate = getFirstInstanceDateUTC(firstInstanceUtc);

    return getCurrentMonthlyCycleEndDate({
      firstInstanceStartDate,
      currentMonthlyCycleStartDate: firstInstanceStartDate,
      durationMinutes,
      refreshPeriodMonthsCount,
    });
  }

  return getFirstInstanceDateUTC(firstInstanceEndDateUtc);
};
